<div class="mat-dialog-container">
    <h2 mat-dialog-title class="dialog-title">
        <span class="title-text">{{message}}</span>
    </h2>
    <mat-dialog-content>
        <mat-form-field class="w-px-300">
            <mat-label>{{label}}</mat-label>
            <input matInput type="text" [(ngModel)]="value"
                id="input">
            <mat-icon *ngIf="helpText != null" matSuffix matTooltip="{{helpText}}">help</mat-icon>
        </mat-form-field>

    </mat-dialog-content>
    <mat-dialog-actions class="justify-flex-end">
        <button mat-raised-button color="primary" id="confirm-accept-button" (click)="handleClose()"
            [disabled]="!value">Confirm</button>
    </mat-dialog-actions>
</div>